import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { RedirectingComponent } from 'src/app/pages/authentication/redirecting/redirecting.component';
import { UnauthorizedComponent } from 'src/app/pages/authentication/unauthorized/unauthorized.component';
import { FullComponent } from 'src/app/layouts/full/full.component';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
import { resolvePageName, userAuthGuard } from 'src/app/services/user-auth.service';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'redirecting' },
  { path: 'redirecting', component: RedirectingComponent },
  // Account setup (OMNI-3429): the onboarding wizard takes the whole screen, outside the app layout. Before the
  // layout routes, whose '**' would otherwise claim it.
  {
    path: 'AccountSetup',
    canActivate: [autoLoginPartialRoutesGuard, userAuthGuard],
    loadComponent: () =>
      import('src/app/onboarding/onboarding-wizard.component').then((m) => m.OnboardingWizardComponent),
    resolve: {
      title: resolvePageName,
    },
  },
  {
    path: '',
    component: FullComponent,
    // Requires a signed-in user for every page below, on entry and on each
    // navigation between them. When signed out the guard starts the login
    // redirect and cancels the navigation, so nothing renders while the
    // browser is on its way to the login page.
    canActivate: [autoLoginPartialRoutesGuard],
    canActivateChild: [autoLoginPartialRoutesGuard],
    loadChildren: () => import('../app/pages/pages.routes').then((m) => m.PagesRoutes),
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'forbidden',
        component: UnauthorizedComponent,
        resolve: {
          title: resolvePageName,
        },
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        resolve: {
          title: resolvePageName,
        },
      },
      {
        path: '**',
        component: PageNotFoundComponent,
        resolve: {
          title: resolvePageName,
        },
      },
    ],
  },
];
